import { render } from "./EditOrCreateClientView.vue?vue&type=template&id=3a939a94"
import script from "./EditOrCreateClientView.vue?vue&type=script&lang=js"
export * from "./EditOrCreateClientView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__